import { Component, Inject, Injectable,ViewChild, ElementRef, OnInit  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ChatService } from '../../service/chat-service';
import { ConstantConfig } from '../../utility/constant-config';
@Injectable({
  providedIn: 'root'
})
@Component({
    selector: 'app-video-confirmation-dialog',
    templateUrl: './video-confirmation-dialog.component.html',
    styleUrls: ['./video-confirmation-dialog.component.scss'],
    standalone: false
})

export class VideoConfirmationDialogComponent implements CanActivate, OnInit{
  isPlaying = false;
  role: string = "";
  config: any = ConstantConfig;
  @ViewChild('videoPlayer') videoElement: ElementRef | undefined;
  videoSource = ''; // Adjust path to your video file
  constructor(
    public dialogRef: MatDialogRef<VideoConfirmationDialogComponent>,private router: Router,private dialog: MatDialog,
    private chatService: ChatService
   // @Inject(MAT_DIALOG_DATA) public data: { videoUrl: string }
  ) {}
  
  ngOnInit(): void {
    this.role = sessionStorage.getItem("role");
    if(this.role === this.config.Role.Trainee) {
      this.videoSource = '../../../assets/video/aiadvisor_Quick_Reference_Guide_Trainee.mp4';
    }
    if(this.role === this.config.Role.Trainer) {
      this.videoSource = '../../../assets/video/aiadvisor_Quick_Reference_Guide_Trainer.mp4';
    }
    if(this.role === this.config.Role.Supervisor) {
      this.videoSource = '../../../assets/video/aiadvisor_Quick_Reference_Guide_Admin.mp4';
    }
  }
  canActivate(): boolean {
    this.dialog.open(VideoConfirmationDialogComponent, {
      width: '600px',
      disableClose: true // Optionally prevent closing by clicking outside
    });
    return false;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
    const payload={
      "firsttime_flag":'Y'
    }
    this.chatService.updateUserProfile(payload,parseInt(sessionStorage.getItem('userId'))).subscribe((response)=>
      {
        // Response from update profile value
      });
  }
  togglePlayback() {
    if (this.videoElement && this.videoElement.nativeElement) {
      const video: HTMLVideoElement = this.videoElement.nativeElement;

      if (video.paused || video.ended) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
    }
  }
  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
